export const SINGULAR_TAGS: { [key: string]: string } = {
	"VGFnOnBhZWRpYS10YWctMQ==": "Themenheft (BAK-zertifiziert)",
	"VGFnOlRhZzo0MGYyY2VlMy02YTUyLTRhMWMtYTAwMC0zZjk0YWUxOTdmZDY=": "Infectopharm Produktschulung",
	"VGFnOlRhZzphZTk4OWRjNC05MmZiLTQ5ODQtOWRjMy0yOTY0NTZkYjU2ZjY=":
		"Onlineschulung (BAK-zertifiziert)",
	"VGFnOlRhZzplNjc2YTc1Yy00YTY5LTRhY2EtYjZjMi03ZThjMzI0ODgwYjg=": "Pädia Produktschulung",
};
